export default __webpack_public_path__ + "static/media/Alex Lee.61ac6617.jpg";